<template>
  <div class="list row">
    <h2>LTR kalkulacije</h2>
    <div class="actions d-flex flex-row-reverse">
      <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
      <button type="button" class="btn btn-success bi bi-plus me-2" @click="goNewBasic"> Dodaj novu </button>
    </div>
    <data-table url="ltr-calculations" :columns="columns" :headings="headers" :actions="actions" :templates="templates"
      ref="datatable" name="LTRCalculations" />

    <!-- Vehicle Type Selection Modal -->
    <div v-if="showVehicleTypeModal" class="modal-backdrop-custom" @click.self="showVehicleTypeModal = false">
      <div class="modal-dialog-custom">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nova kalkulacija — tip vozila</h5>
            <button type="button" class="btn-close" @click="showVehicleTypeModal = false"></button>
          </div>
          <div class="modal-body p-0">
            <div class="list-group list-group-flush">
              <button type="button" class="list-group-item list-group-item-action px-4 py-3"
                @click="confirmVehicleType('new')">
                Novo vozilo
              </button>
              <button type="button" class="list-group-item list-group-item-action px-4 py-3"
                @click="confirmVehicleType('used_primero')">
                Polovno vozilo iz flote Primero
              </button>
              <button type="button" class="list-group-item list-group-item-action px-4 py-3"
                @click="confirmVehicleType('used_other')">
                Polovno vozilo — nije vlasništvo Primero
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "../widgets/DataTable.vue";
import dateUtils from "../../utils/date-common";
import LtrCalcService from "../../services/ltr-calculation.service";

export default {
  name: 'ltr-calculations',
  components: { DataTable },
  data() {
    return {
      showVehicleTypeModal: false,
      columns: ["id", "title", "period_from", "period_to", "vehicle_model", "customer", "financier", "vehicle_type_selection", "status", "vehicle_value_list_pdv_discounted", "edit", "edit_basic"],
      headers: {
        id: "ID",
        title: 'Naziv',
        period_from: 'Od',
        period_to: 'Do',
        vehicle_model: 'Model vozila',
        customer: 'Kupac',
        financier: 'Finansijer',
        vehicle_type_selection: 'Tip',
        vehicle_value_list_pdv_discounted: 'Vrednost vozila',
        status: 'Status',
        edit: '',
        edit_basic: '',
      },
      actions: {
        edit: { action: (row) => this.goEditBasic(row), icon: 'bi-pencil', title: 'Izmeni (Advanced)' },
        // edit_basic: { action: (row) => this.goEditBasic(row), icon: 'bi-pencil-square', color: 'info', title: 'Izmeni (Basic)' },
        delete: { deleteData: this.deleteData, color: 'danger', icon: 'bi-trash' },
      },
      templates: {
        period_from(h, row) {
          return dateUtils.formatDate(row.period_from);
        },
        period_to(h, row) {
          return dateUtils.formatDate(row.period_to);
        },
        vehicle_type_selection(_h, row) {
          const labels = { new: 'Novo', used_primero: 'Polovno - Primero', used_other: 'Polovno - Ostalo' };
          return labels[row.vehicle_type_selection] || '-';
        },
      },
    }
  },
  methods: {
    refreshData() { this.$refs.datatable.onRefresh(); },
    goNew() { this.$router.push({ name: 'ltr-new' }); },
    goNewBasic() { this.showVehicleTypeModal = true; },
    confirmVehicleType(type) {
      this.showVehicleTypeModal = false;
      this.$router.push({ name: 'ltr-basic-new', query: { vehicleType: type } });
    },
    goEdit(row) { this.$router.push({ name: 'ltr-edit', params: { id: row.id } }); },
    goEditBasic(row) { this.$router.push({ name: 'ltr-basic-edit', params: { id: row.id } }); },
    async deleteData(id) {
      await LtrCalcService.delete(id);
      this.$store.commit("app/showAlert", { type: 'success', message: 'Obrisano' });
      this.refreshData();
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    }
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  margin: auto;
}

.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog-custom {
  background: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 24px rgba(0,0,0,0.2);
}
</style>
